<template>
    <div class="m-omitUser">
        <el-form class="chart-query" :model="chartSearch" :inline="true" size="small">
            <el-form-item>
                <advanced-date-picker v-model="chartSearch.time"></advanced-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="getChartData(1)" round>{{$t('c.query')}}</el-button>
            </el-form-item>
        </el-form>

        <el-row :gutter="20" class="mt10">
            <el-col :span="6">
                <div class="box-org">
                    <statistics-multi-orgs @orgsChange="orgsChange" @dataLoaded="orgDataLoaded"></statistics-multi-orgs>
                </div>
            </el-col>

            <el-col :span="18" class="relative">
                <stats-chart ref="userChart" type="bar" title="哪些安检员漏得最多" />
            </el-col>
        </el-row>

        <el-row :gutter="20" class="mt20">
            <el-col :span="8">
                <stats-chart ref="ageChart" type="pie" title="年龄段与漏检物品种类" />
            </el-col>

            <el-col :span="8">
                <stats-chart ref="genderChart" type="pie" title="性别与漏检物品种类" />
            </el-col>

            <el-col :span="8">
                <stats-chart ref="gradeChart" type="pie" title="岗位资质与漏检物品种类" />
            </el-col>
        </el-row>

        <ui-card class="table-box mt20" title="安检员漏检记录" icon="nucfont inuc-list-chart">
            <el-form class="table-query" :inline="true" size="mini">
                <el-form-item label="个人信息">
                    <el-input v-model="formSearch.name" :placeholder="$t('tip.userSearch')"
                              @keyup.enter.native="getTableData(1)" clearable></el-input>
                </el-form-item>
                <!--组织机构-->
                <select-multi-orgs @orgsChange="formOrgsChange"></select-multi-orgs>
                <el-form-item label="漏检时间">
                    <advanced-date-picker v-model="formSearch.time" selector="select"></advanced-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="getTableData(1)" round>{{$t('c.query')}}</el-button>
                </el-form-item>
            </el-form>
            <data-tables class="omit-table"
                         :data="tableData"
                         :table-props="tableProps"
                         :current-page.sync="currentPage"
                         :page-size="20"
                         :pagination-props="{pageSizes: [20, 50, 100, 300, 500]}"
            >
                <el-table-column type="index" width="40" align="center"></el-table-column>
                <el-table-column v-for="(title, index) in titles" :prop="title.prop" :label="title.label" :key="index"
                                 align="center"
                                 show-overflow-tooltip
                                 :sortable="title.sortable">
                </el-table-column>
                <el-table-column :label="$t('c.operation')" align="center" width="140">
                    <div class="btn-cell" slot-scope="scope">
                        <i class="nucfont inuc-preview" :title="$t('c.view')" @click="viewUserDetail(scope.row)"></i>
                    </div>
                </el-table-column>
            </data-tables>
        </ui-card>
    </div>
</template>

<script>
    import { Debounce } from '@/utils'
    import StatisticsMultiOrgs from '@/components/Statistics/StatisticsMultiOrgs'
    import SelectMultiOrgs from '@/components/SelectMultiOrgs'
    import AdvancedDatePicker from '@/components/DatePickerAdvanced'
    import uiCard from '@/components/Statistics/StatisticUICard.vue'
    import StatsChart from "@/components/Statistics/StatsChart"

    export default {
        components: {
            StatisticsMultiOrgs,
            SelectMultiOrgs,
            AdvancedDatePicker,
            uiCard,
            StatsChart
        },

        data() {
            return {
                chartSearch: {
                    orgIds: [],
                    time: [],
                },

                formSearch: {
                    orgIds: [],
                    name: '',
                    accountNo: '',
                    time: '',
                },
                tableData: [],
                tableProps: {
                    border: false,
                    stripe: true,
                    height: 360
                },
                currentPage: 1,
                titles: [
                    {
                        prop: 'name',
                        label: '姓名'
                    }, {
                        prop: 'orgName',
                        label: '机构'
                    }, {
                        prop: 'accountNo',
                        label: '账号',
                    }, {
                        prop: 'genderName',
                        label: '性别',
                        sortable: 'custom'
                    }, {
                        prop: 'age',
                        label: '年龄',
                        sortable: 'custom'
                    }, {
                        prop: 'grade',
                        label: '资质',
                    }, {
                        prop: 'knowledgeName',
                        label: '漏检最多种类',
                    }, {
                        prop: 'total',
                        label: '漏检总数量',
                        sortable: 'custom'
                    }
                ],
            }
        },

        computed: {

        },

        mounted() {
            this.getTableData()
        },

        methods: {
            getChartData() {
                let queryData = {
                    orgIds: this.chartSearch.orgIds,
                    startTime: this.chartSearch.time[0],
                    endTime: this.chartSearch.time[1],
                }

                // 谁漏得最多
                this.$api.omitTop(queryData).then(res => {
                    let data = res.package
                    let series = data.series.map(item => {
                        return {
                            name: item.name,
                            type: 'bar',
                            label: {
                                show: true,
                                position: 'insideBottom',
                                distance: 15,
                                formatter(params) {
                                    return params.value && `${params.seriesName} ${params.value}` || ''
                                },
                                fontSize: 16,
                                rotate: 90,
                                align: 'left',
                                verticalAlign: 'middle'
                            },
                            barMaxWidth: 40,
                            data: item.data
                        }
                    })

                    this.$refs.userChart.drawChart({
                        category: data.xaxis.title,
                        series
                    })
                })

                this.$api.ageOmitTop(queryData).then(res => {
                    let data = res.package
                    data.innerRing.map(item => {
                        item.name = item.name || '未设置'
                        return item
                    })
                    this.$refs.ageChart.drawChart({
                        data,
                        name: ['年龄段', '物品种类'],
                        showLegend: false
                    })
                })

                this.$api.genderOmitTop(queryData).then(res => {
                    let data = res.package
                    data.innerRing.map(item => {
                        item.name = item.name || '未设置'
                        return item
                    })
                    this.$refs.genderChart.drawChart({
                        data,
                        name: ['性别', '物品种类'],
                        showLegend: false
                    })
                })

                this.$api.gradeOmitTop(queryData).then(res => {
                    let data = res.package
                    data.innerRing.map(item => {
                        item.name = item.name || '未设置'
                        return item
                    })
                    this.$refs.gradeChart.drawChart({
                        data,
                        name: ['岗位资质', '物品种类'],
                        showLegend: false
                    })
                })

            },

            async getTableData(num) {
                if (num) this.currentPage = num

                let queryData = {
                    ...this.formSearch,
                    startTime: this.formSearch.time[0],
                    endTime: this.formSearch.time[1],
                }

                delete queryData.time

                let res = await this.$api.queryUserOmit(queryData)
                this.tableData = res.package
            },

            viewUserDetail({id, name}) {
                this.$router.push({name: 'omitUserDetailStats', params: {userID: id, name: name}})
            },

            orgDataLoaded() {
                this.$nextTick(() => {
                    $('.m-omitUser .el-tree > .el-tree-node').eq(0).find('.el-checkbox:eq(0)').click();
                })
            },
            orgsChange: Debounce(function (data) {
                this.chartSearch.orgIds = data;

                this.getChartData()
            }, 500),

            formOrgsChange(data) {
                this.formSearch.orgIds = data;
            },

        },
    }
</script>

<style lang="scss">

    .m-omitUser {


    }
</style>
